import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Observable} from "rxjs";
import {GetCustomersCB} from "../../Ope/Customer/GetCustomersCB";
import {GetAllCustomersCB} from "../../Ope/Customer/GetAllCustomersCB";
import {PutCustomerCB} from "../../Ope/Customer/PutCustomerCB";
import {DelCustomerCB} from "../../Ope/Customer/DelCustomerCB";
import {ChangeCustomerOwnerCB} from "../../Ope/Customer/ChangeCustomerOwnerCB";
import {GetAllChargersCB} from "../../Ope/Charger/GetAllChargersCB";
import {GetChargersCB} from "../../Ope/Charger/GetChargersCB";
import {PutChargerCB} from "../../Ope/Charger/PutChargerCB";
import {DelChargerCB} from "../../Ope/Charger/DelChargerCB";

@Injectable({
  providedIn: 'root'
})
export class ChargerService extends BaseService {

  public getAllChargers(cb: GetAllChargersCB): Observable<any> {
    return this.execOPE(cb);
  }
  public getChargers(cb: GetChargersCB): Observable<any> {
    return this.execOPE(cb);
  }
  public putCharger(cb: PutChargerCB): Observable<any> {
    return this.execOPE(cb);
  }
  public delCharger(cb: DelChargerCB): Observable<any> {
    return this.execOPE(cb);
  }


}
